import { styled } from 'styled-components'

export const Content = styled.div`
  width: 100%;
  margin: auto;
  max-width: 720px;
  padding: var(--padding-m) var(--padding-s) var(--padding-l);
  figure {
    margin: var(--padding-m) 0 var(--padding-l);
  }
  figcaption {
    a {
      display: inline-block;
      color: var(--highlight);
      border-bottom: 1px solid var(--highlight);
      text-overflow: ellipsis;
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
    }
    span {
      color: var(--highlight);
    }
  }
  img {
    width: 100%;
  }
  video {
    width: 100%;
  }
  > p {
    margin-bottom: var(--padding-l);
  }
`

